import React from 'react';
import Button from 'devextreme-react/button';

import CoreUtils from '../../../common/utils/CoreUtils';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';

import BooleanEditor from '../../../common/metadata/BooleanEditor';
import NumberEditor from '../../../common/metadata/NumberEditor';
import StringEditor from '../../../common/metadata/StringEditor';

export default class TableauPageView extends DataItemView {
  static displayName = TableauPageView.name;

  constructor(props) {
    super(props);

    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.tableauPage);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.tableauPage);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <div className={this.getTableauPageViewClassNames(this.state.isDeleted)}>
        <table><tbody>
          <tr className="pwx-field">
            <td className="pwx-field-label">Page Title:</td>
            <td className="pwx-field-spacer" />
            <td className="pwx-field-value" colSpan="6">
              <StringEditor name="pageTitle" value={this.state.pageTitle} onValueChanged={this.onEditorValueListener} />
              <ModifiedFlag isModifiedProperty={this.state.pageTitle_isModified} />
              <ErrorFlag errorProperty={this.state.pageTitle_error} />
            </td>
          </tr>
          <tr className="pwx-field">
            <td className="pwx-field-label">Page URL:</td>
            <td className="pwx-field-spacer" />
            <td className="pwx-field-value" colSpan="6">
              <StringEditor name="pageUrl" size="37" value={this.state.pageUrl} onValueChanged={this.onEditorValueListener} />
              <ModifiedFlag isModifiedProperty={this.state.pageUrl_isModified} />
              <ErrorFlag errorProperty={this.state.pageUrl_error} />
            </td>
          </tr>
          <tr className="pwx-field">
            <td className="pwx-field-label">Is Visible:</td>
            <td className="pwx-field-spacer" />
            <td className="pwx-field-value" width="40px">
              <BooleanEditor name="pageIsVisible" value={this.state.pageIsVisible} onValueChanged={this.onEditorValueListener} />
              <ModifiedFlag isModifiedProperty={this.state.pageIsVisible_isModified} />
              <ErrorFlag errorProperty={this.state.pageIsVisible_error} />
            </td>
            <td className="pwx-field-spacer" width="70px" />
            <td className="pwx-field-label" width="85px">Display Order:</td>
            <td className="pwx-field-spacer" />
            <td className="pwx-field-value">
              <NumberEditor name="displayOrderIndex" value={this.state.displayOrderIndex} onValueChanged={this.onEditorValueListener} />
              <ModifiedFlag isModifiedProperty={this.state.displayOrderIndex_isModified} />
              <ErrorFlag errorProperty={this.state.displayOrderIndex_error} />
            </td>
            <td width="auto" />
          </tr>
        </tbody></table>
        <div className="pwx-tableau-page-remove">
          <Button type="normal" icon="remove" onClick={this.onRemoveButtonClicked.bind(this)} />
        </div>
      </div>
    );
  }

  getTableauPageViewClassNames(isDeleted) {
    var classNames = 'pwx-tableau-page-view';
    if (isDeleted)
      classNames += ' pwx-item-deleted';

    return classNames;
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }

  onRemoveButtonClicked() {
    if (CoreUtils.isDefinedAndNotNull(this.props.onRemoveTableauPage))
      this.props.onRemoveTableauPage(this.dataItem);
  }
}